import React from 'react';

import DraggableWrapper from '@/components/DndWrappers/Draggable';

import type { NotesItem } from '@/types/global';

import OkIcon from '@/assets/icons/ok.svg?react';

type Props = {
  item: NotesItem;
  index: number;
  onClick: () => void;
};

const SingleNote: React.FC<Props> = ({ item, index, onClick }) => {
  return (
    <div className="notes__item-wrapper">
      <DraggableWrapper
        draggableId={`${item._id}-${item.title}`}
        index={index}
        className="notes__item"
        onClick={onClick}
      >
        <div className="notes__item-name">{item.title}</div>
        {item.isReminded && (
          <div className="notes__item-dates">
            <span className="notes__item-date">{item.dueDate}</span>
            <span className="notes__item-time">{item.dueTime}</span>
          </div>
        )}

        {item.status === 'done' && (
          <div className="notes__item-done">
            <OkIcon />
          </div>
        )}
      </DraggableWrapper>
    </div>
  );
};

export default SingleNote;
